module.exports = __webpack_public_path__ + "img/q_qstake.ab532d7.png";